var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3 6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6Z",
    stroke: "#9AA0AB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2v4M8 2v4M3 10h18",
    stroke: "#9AA0AB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgCalendar as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M3 6C3 4.89543 3.89543 4 5 4H19C20.1046 4 21 4.89543 21 6V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V6Z' stroke='%239AA0AB' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M16 2V6' stroke='%239AA0AB' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M8 2V6' stroke='%239AA0AB' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M3 10H21' stroke='%239AA0AB' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E %3C/svg%3E";